import React from 'react'

import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded'
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded'
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded'
import PauseRoundedIcon from '@mui/icons-material/PauseRounded'
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded'
import StopRoundedIcon from '@mui/icons-material/StopRounded'

type CampaignStatusIconProps = {
  status: string
}

const CampaignStatusIcon = ({ status }: CampaignStatusIconProps) => {
  switch (status) {
    case 'running':
      return <PlayArrowRoundedIcon style={{ color: 'green' }} titleAccess="running" />
    case 'paused':
      return <PauseRoundedIcon style={{ color: 'orange' }} titleAccess="paused" />
    case 'stopped':
      return <StopRoundedIcon style={{ color: '#E6594F' }} titleAccess="stopped" />
    case 'review':
      return <AssignmentRoundedIcon style={{ color: '#1C4167' }} titleAccess="review" />
    case 'accepted':
      return <AssignmentTurnedInRoundedIcon style={{ color: 'gray' }} titleAccess="accepted" />
    case 'finished':
      return <CheckBoxRoundedIcon style={{ color: 'gray' }} titleAccess="finished" />
    default:
      return ''
  }
}

export default CampaignStatusIcon
